import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

// cols: [{ label, value: (row) => any }]
const matrix = (rows, cols) => rows.map((r) => cols.map((c) => { const v = c.value(r); return v === null || v === undefined ? "" : v; }));
const stamp = () => new Date().toISOString().slice(0, 10);

export function exportExcel(rows, cols, name, totals) {
  const data = [cols.map((c) => c.label), ...matrix(rows, cols), ...(totals ? [totals] : [])];
  const ws = XLSX.utils.aoa_to_sheet(data);
  ws["!cols"] = cols.map((c) => ({ wch: Math.max(c.label.length + 2, c.wch || 14) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, name.slice(0, 31));
  XLSX.writeFile(wb, `${name.replace(/\s+/g, "-").toLowerCase()}-${stamp()}.xlsx`);
}

const pdfMoney = (v) => (typeof v === "number" ? `Rs. ${Math.round(v).toLocaleString("en-IN")}` : v);

export function exportPdf(rows, cols, title, subtitle, totals) {
  const doc = new jsPDF({ orientation: cols.length > 6 ? "landscape" : "portrait", unit: "pt", format: "a4" });
  doc.setFontSize(14);
  doc.text(title, 40, 36);
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(`${subtitle ? `${subtitle} · ` : ""}${rows.length} records · Generated ${new Date().toLocaleString("en-IN")}`, 40, 52);
  const fmt = (r) => cols.map((c) => { const v = c.value(r); return c.money ? pdfMoney(v || 0) : v ?? ""; });
  autoTable(doc, {
    startY: 64, head: [cols.map((c) => c.label)], body: rows.map(fmt),
    foot: totals ? [totals.map((v, i) => (cols[i]?.money && typeof v === "number" ? pdfMoney(v) : v))] : undefined,
    styles: { fontSize: 8, cellPadding: 4 }, headStyles: { fillColor: [49, 46, 129] }, footStyles: { fillColor: [241, 245, 249], textColor: 20 },
    margin: { left: 30, right: 30 },
  });
  doc.save(`${title.replace(/\s+/g, "-").toLowerCase()}-${stamp()}.pdf`);
}

export const sumCol = (rows, f) => rows.reduce((s, r) => s + (Number(f(r)) || 0), 0);
